import React from 'react';
import { kmToMiles } from '../../utils/distance';

const statusBadge = (status) => {
  if (status === 'Least Concern') return { abbr: 'LC', color: 'secondary' };
  if (status === 'Near Threatened') return { abbr: 'NT', color: 'primary' };
  if (status === 'Vulnerable') return { abbr: 'VU', color: 'primary' };
  if (status === 'Endangered') return { abbr: 'EN', color: 'error' };
  if (status === 'Critically Endangered') return { abbr: 'CR', color: 'error' };
  return { abbr: '?', color: 'primary' };
};

const SpeciesCard = ({ species, isSelected, onClick }) => {
  const badge = statusBadge(species.status);

  return (
    <button
      onClick={() => onClick(species.id)}
      className={`group relative w-full text-left p-4 rounded-2xl transition-all duration-500 cursor-pointer ${
        isSelected
          ? 'bg-surface-bright/60'
          : 'bg-surface-container-highest/40 hover:bg-surface-bright/60'
      }`}
    >
      <div className="flex items-start gap-4">
        <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 bg-surface-container-low">
          {species.image ? (
            <img
              src={species.image}
              alt={species.name}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="text-3xl">{species.icon}</span>
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-start">
            <h3 className="font-headline text-lg leading-tight group-hover:text-primary transition-colors text-on-surface">
              {species.name}
            </h3>
            <span className={`bg-${badge.color}/10 text-${badge.color} text-[9px] px-2 py-0.5 rounded-full font-label`}>
              {badge.abbr}
            </span>
          </div>
          <p className="text-xs text-slate-400 mt-0.5 italic font-body">{species.scientificName}</p>
          <div className="mt-3 flex items-center gap-4">
            <div className="flex flex-col">
              <span className="text-[9px] text-slate-500 uppercase font-label">Distance</span>
              <span className="text-[11px] font-medium text-on-surface">{kmToMiles(species.distance)}</span>
            </div>
            <div className="w-[1px] h-4 bg-white/5"></div>
            <div className="flex flex-col">
              <span className="text-[9px] text-slate-500 uppercase font-label">Status</span>
              <span className={`text-[11px] font-medium ${
                species.status === 'Least Concern' ? 'text-secondary' :
                species.status === 'Near Threatened' ? 'text-primary' :
                species.status === 'Endangered' || species.status === 'Critically Endangered' ? 'text-error' :
                'text-on-surface-variant'
              }`}>
                {species.status}
              </span>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};

export default SpeciesCard;
